<script>
	import { SwiperSlide } from 'swiper/svelte';
    import Video from './Video.svelte';
    import VideoSlider from "./VideoSlider.svelte";
    import { onMount } from 'svelte';
    // import {baseURL, RESTClient} from '../utils/rest';
    // let videos = [];
	//  const client = new RESTClient();
	//  client.get('videos?_limit=-1').then(res => {
    //      //videos = res;
    //       videos = res.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    //       console.log(videos)
    // });
   
</script>

<div class="home-videos" id="videos">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-10 col-xs-12 video-slide-container mx-auto">
                <div class="overlap-title">
                    <h1 class="primary-title">videos</h1>
                    <h4 class="secondary-title">Videos</h4>
                </div>
                <div class="d-flex justify-content-center signel-video">
                    <Video url="https://www.youtube.com/watch?v=PFgEnmPBgys" thumb="/images/video-thumb.png"/>
                </div>
                <!-- <VideoSlider>
                    <SwiperSlide>
                        <Video url="https://www.youtube.com/watch?v=VPrxkvClUVU" thumb="/images/frGAezPhY8M-HD.jpg"/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Video url="https://www.youtube.com/watch?v=wDZI3legYxs" thumb="/images/frGAezPhY8M-HD.jpg"/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Video url="https://www.youtube.com/watch?v=v358sY-0flg&t" thumb="/images/frGAezPhY8M-HD.jpg"/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Video url="https://www.youtube.com/watch?v=ytARbkx-9Og&t" thumb="/images/frGAezPhY8M-HD.jpg"/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Video url="https://www.youtube.com/watch?v=mIp2064WWJA&t" thumb="/images/frGAezPhY8M-HD.jpg"/>
                    </SwiperSlide>
                </VideoSlider> -->
                <!-- {#if videos.length}
                <VideoSlider>
                    {#each videos.slice(0, 6) as video}
                        <SwiperSlide>
                            <Video {video}/>
                        </SwiperSlide>
                    {/each}
                </VideoSlider>
                    {:else}
                    <VideoSlider>
                        <SwiperSlide>
                            <Video url="https://www.youtube.com/watch?v=VPrxkvClUVU" thumb="/images/VPrxkvClUVU-HD.jpg"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Video url="https://www.youtube.com/watch?v=wDZI3legYxs" thumb="/images/wDZI3legYxs-HD.jpg"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Video url="https://www.youtube.com/watch?v=v358sY-0flg&t" thumb="/images/v358sY-0flg-HD.jpg"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Video url="https://www.youtube.com/watch?v=ytARbkx-9Og&t" thumb="/images/ytARbkx-9Og-HD.jpg"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Video url="https://www.youtube.com/watch?v=mIp2064WWJA&t" thumb="/images/mIp2064WWJA-HD.jpg"/>
                        </SwiperSlide>
                    </VideoSlider>
                {/if} -->
                <!-- <div class="text-center mt-4">
                    <a href="/videos" class="btn bordered-btn">See all videos</a>
                </div> -->
            </div>
        </div>
    </div> 
</div>

<style>
    
</style>